const ALLOWED_TAGS = new Set([
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  'ul',
  'ol',
  'li',
  'a',
  'span',
  'sub',
  'sup'
]);

const SAFE_URL_PATTERN = /^(https?:|mailto:|tel:|#)/i;

const sanitizeChildren = (parent, doc) => {
  let current = parent.firstChild;

  while (current) {
    const next = current.nextSibling;

    if (current.nodeType === 1) {
      const tagName = current.tagName.toLowerCase();

      if (!ALLOWED_TAGS.has(tagName)) {
        if (tagName === 'div') {
          // Convert div to p to preserve paragraph/line spacing from contentEditable
          const p = doc.createElement('p');
          while (current.firstChild) {
            p.appendChild(current.firstChild);
          }
          parent.replaceChild(p, current);
          sanitizeChildren(p, doc);
          current = next;
          continue;
        }

        while (current.firstChild) {
          parent.insertBefore(current.firstChild, current);
        }
        parent.removeChild(current);
        sanitizeChildren(parent, doc);
        return;
      }

      const attributes = Array.from(current.attributes);
      for (const attr of attributes) {
        const name = attr.name.toLowerCase();
        const isAllowedLinkAttr =
          tagName === 'a' && (name === 'href' || name === 'target' || name === 'rel');

        if (!isAllowedLinkAttr) {
          current.removeAttribute(attr.name);
        }
      }

      if (tagName === 'a') {
        const href = (current.getAttribute('href') || '').trim();
        if (!SAFE_URL_PATTERN.test(href)) {
          current.removeAttribute('href');
        }

        if (current.getAttribute('target') === '_blank') {
          current.setAttribute('rel', 'noopener noreferrer');
        }
      }

      sanitizeChildren(current, doc);
    } else if (current.nodeType === 8) {
      parent.removeChild(current);
    }

    current = next;
  }
};

export const sanitizeRichText = (input = '') => {
  if (!input) {
    return '';
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${input}</div>`, 'text/html');
  const wrapper = doc.body.firstElementChild;

  if (!wrapper) {
    return '';
  }

  sanitizeChildren(wrapper, doc);
  return wrapper.innerHTML.trim();
};

export const hasHtmlTags = (input = '') => /<\/?[a-z][\s\S]*>/i.test(input);

export const richTextToPlainText = (input = '') => {
  if (!input) {
    return '';
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(input, 'text/html');
  return (doc.body.textContent || '').trim();
};
